"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormSection = exports.InputContainer = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var InputContainer = function InputContainer(_ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? 'col-span-6' : _ref$classes,
      label = _ref.label,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "first_name",
    className: "block text-sm font-medium leading-5 text-gray-700"
  }, label), children);
};

exports.InputContainer = InputContainer;

var FormSection = function FormSection(_ref2) {
  var title = _ref2.title,
      info = _ref2.info,
      inputs = _ref2.inputs,
      state = _ref2.state,
      onChange = _ref2.onChange,
      children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-w-7xl mx-auto pt-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-white shadow-md px-4 pt-3 pb-5 sm:rounded-sm sm:p-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "md:grid md:grid-cols-3 md:gap-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "md:mt-0 md:col-span-3 border border-red-600"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-6 gap-6"
  }, children)))));
};
/*{inputs.map((input,i) => {
                const Input = Inputs[input.type] || Inputs['default']
                return(
                  <InputContainer {...input} key={i}>
                    <Input 
                      onChange={onChange}
                      state={state}
                      {...input} 
                    />
                  </InputContainer>
                )
              })}*/


exports.FormSection = FormSection;